import { ReactComponent as LogoLauriaMiniIcon } from 'core/assets/images/general/logoLauriaMini.svg'
import { useTranslation } from 'react-i18next'

export const GoToIasuite = () => {
  const { t } = useTranslation()
  return (
    <div className="go-to-iasuite-button">
      <div>{t('goToIasuite')}</div>
      <LogoLauriaMiniIcon className="w-[40px] h-[40px]" />
    </div>
  )
}
